<template>
    <v-card>
        <v-card-title class="accent white--text subheading">
            Supervised Detection Scores (Higher indicates error)
        </v-card-title>
        <v-card-text>
            <loading-progress-bar :loading="loading"></loading-progress-bar>
            <vue-plotly disable-responsive :data="mydata" :layout="layout" :options="options" @click="handleClick"></vue-plotly>
        </v-card-text>
    </v-card>
</template>

<script>
  import {getSupervisedResults, getModel} from '@/helper'
  import VuePlotly from '@/components/VuePlotly'
  import LoadingProgressBar from '../LoadingProgressBar'
  import _ from 'lodash'
  import {addMinutes, compareAsc} from 'date-fns'

  export default {
    name: 'SupervisedSummary',
    components: { LoadingProgressBar, VuePlotly},
    props:{
      range: Object,
      equipment: String
    },
    data () {
      return {
        loading: true,
        df: null,
        layout: {
          autosize: true,
          hovermode: 'closest',
          height:400,
          margin: {
              l: 400,
          },
          yaxis: {
            title: 'Health',
          },
          xaxis: {
            title: 'timestamp'
          }},
        options: {},
        mydata: [],
        mydata2: [],
        layout2: {
          autosize: true,
          hovermode: 'closest',
          yaxis: {
            title: 'Sensor'
          },
          xaxis: {
            title: 'Sensor'
          },
          title: {text: ''}
        },
        currentTime: null,
        models: []
      }
  },
    watch: {
    range () {
      this.refresh()
    },
    equipment () {
      this.refresh()
    }
    },
    computed: {
      facilityName () {
        return this.$store.state.pointsListStore.pointsList.facility_name
      },
      modelDict () {
        let output = {}
        for (let i in this.models) {
          output[this.models[i]['model_id']] = this.models[i]
        }
        return output
      }
    },
    methods: {
      async refresh () {
        this.loading = true
        this.models = (await getModel(
          {'facility_name': this.facilityName}
          ))['result']

        let df = await getSupervisedResults(
          this.equipment,
          this.facilityName,
          {'start': this.range.start, 'end': this.range.end}
        )
          this.$emit('vischange',df.timestamp.length>0||df.model_id.length>0 )

        let currentTime = _.min(df['timestamp'])
        let endTime = _.max(df['timestamp'])
        while (compareAsc(currentTime,endTime)<0) {
          currentTime = addMinutes(currentTime, this.$store.getters.minutesBetweenSamples)
          df['value'].push(null)
          df['model_id'].push(-1)
          df['timestamp'].push(currentTime)
        }
        //console.log(this.modelDict)
        let self = this
          let colorscaleValue = [
              [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
              [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
          ]
        this.mydata = [{
          x: df['timestamp'],
          y: _.map(df['model_id'], function(id) {
            if (id==-1) return ' '
            return id + '__' + self.modelDict[id]['model_name']
          }),
          z: df['value'],
          type: 'heatmap',
          mode: 'markers',
          colorscale: colorscaleValue,
            zmin:0,
            zmax:1
        }]
        //console.log(df['timestamp'])
        this.loading = false
      },
      handleClick(data) {
        let selectedTime = data.points[0].x
        let selectedTitle = data.points[0].y
        let selectedModelId = selectedTitle.split('__')[0]
        let relevantVariables = this.modelDict[selectedModelId]['relevant_variables'].split(',')
        let startDate = new Date(selectedTime)
        startDate.setDate(startDate.getDate() - 3)
        let endDate = new Date(selectedTime)
        endDate.setDate(endDate.getDate()+3)
        let output = {
          path: '/sensors',
          query: {
            variableX: _.get(relevantVariables,0),
            variableY: _.get(relevantVariables,0),
            rangeStart: startDate.toISOString().slice(0,10),
            rangeEnd: endDate.toISOString().slice(0,10),
            equipment: this.equipment
          }
        }
        this.$router.push(output)
      },
    },
    mounted () {
      this.refresh()
    }
  }
</script>

<style scoped>

</style>
